import Image from 'next/image'
import React from 'react'
import { BaseCard } from '../BaseCard'

export const FeaturedLearnMoreExerciseCard = () => {
    return (
        <BaseCard cardType="tall" boxShadow={false} onClick={null}>
            <Image
                alt={`Races Learn More card image`}
                src={'https://asset.yes.fit/homepage/learn-more-exercises.png'}
                layout="fill"
                objectFit="cover"
                className="bg-gray-800"
            />
            <div className="flex flex-col pt-10 z-10 absolute top-3 left-5">
                <p className="text-pink-300 text-[10px] font-normal">FITNESS</p>
                <p className="mt-2 mb-1.5 text-white text-3xl font-medium leading-none tracking-wide">
                    Exercises
                </p>
                <p className="text-sm font-normal text-white max-w-[180px]">
                    Whether your workout is heating up or cooling down, these exercises
                    are designed to be used anytime. With a variety of durations and
                    focusing on different target areas, these movements will enhance your
                    workouts while improving your form and stamina.
                </p>
                <div>
                    <a
                        href="https://yesfit.app.link/app-store"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <img
                            src="https://asset.yes.fit/homepage/AppStoreBadge.png"
                            className="mt-3 mb-1 max-h-[36px]"
                        />
                    </a>
                    <a
                        href="https://yesfit.app.link/google-play"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <img
                            src="https://asset.yes.fit/homepage/PlaystoreBadge.png"
                            className="max-h-[36px]"
                        />
                    </a>
                </div>
            </div>
        </BaseCard>
    )
}
